import { z } from 'zod';

export const schemaConsorsKycStatus = z.enum(['HIGH_RISK', 'MEDIUM_RISK', 'LOW_RISK', 'FAILED', 'NOT_AVAILABLE']);
